define('modules/editor/views/property_boxes/text_content',['require','exports','module','./base','ckeditor','lib/util','lodash','common/ckeditor/config','ckeditorJQuery','ldsh!../../templates/property_boxes/text_content'],function(require, exports, module) {
  "use strict";

  var BasePropertyBox = require("./base"),
      ckeditor = require("ckeditor"),
      util = require("lib/util"),
      _ = require("lodash"),
      ckeditorConfig = require("common/ckeditor/config");

  require("ckeditorJQuery");

  var Controller = {
    onRequestContent: function(e) {
      e.preventDefault();
      this.model.parent.editText();
      // this.data.services.request("text:content", this.model.get("content"), _.bind(function(text){
      //   this.model.set("content", text);
      // }, this));
    }
  };

  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/text_content"),
    events: {
      "click .js-request-content": "onRequestContent"
    },
    onRender: function(){
       var config = _.extend(ckeditorConfig, {
         resize_enabled:false,
         height:'220px',
       });
      this.$("#ckeditor").ckeditor(config);
      this.$el.i18n();
    },
    onHide: function(){
      //destroy the editor for garbage collection
      this.editor.destroy();
    }
  });

  util.mixin(module.exports, Controller);

});

